module.exports = __webpack_public_path__ + "media/customizations/hawaiian/logo-new-3548fdd353424f316b48190dc3d7b4c2.png";